// extracted by mini-css-extract-plugin
module.exports = {"root":"Title-root-c315e4819ab7d6e506759cc3f2422dcc","icon":"Title-icon-5a7181691642698cdbe49243be5c1ca7","text":"Title-text-382164b17eab5bf8c2c1b8d3bb747e4c"};